import * as React from "react";
// import posed from "react-pose";
import { animated } from "react-spring";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";
import { useOverlay } from "../hooks";
import CloseIcon from "../elements/CloseIcon";

const Base = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  position: relative;
  background-color: white;
  overflow: hidden;
`;

const Content = styled.div<{ scroll?: boolean }>`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  ${p =>
    p.scroll &&
    css`
      align-items: flex-start;
      overflow-y: auto;
    `};
`;

const Inner = styled.div`
  position: relative;
  width: 100%;
  padding: ${select.space(6)} ${select.space(4)} ${select.space(4)};
`;

type WithOverlayConfig = {
  width?: any;
  innerWidth?: any;
  scroll?: boolean;
};

type InnerProps = {
  style?: React.CSSProperties;
};

function withOverlay<P extends {}>(
  { width = "auto", innerWidth = "none", scroll }: WithOverlayConfig,
  Component: React.ComponentType<P>
): React.ComponentType<P & InnerProps> {
  function WithOverlay({ style, ...rest }: P & InnerProps, ref: any) {
    const { hideOverlay } = useOverlay();

    return (
      <Base style={{ ...style, width }} ref={ref}>
        <CloseIcon
          style={{ position: "absolute", top: 16, right: 16, zIndex: 2 }}
          onClick={hideOverlay}
        />
        <Content scroll={scroll}>
          <Inner style={{ maxWidth: innerWidth }}>
            <Component {...(rest as P)} />
          </Inner>
        </Content>
      </Base>
    );
  }

  return animated(React.forwardRef(WithOverlay) as any);
}

export default withOverlay;
